import React, { Fragment, Component } from 'react';
import { DateTimeHelper } from '../../dateTimeHelper';
import './Blog2.scss';
import Swiper from 'react-id-swiper';

class Blog2 extends Component {
    constructor() {
        super();
        this.state = {
            data: []
        }
    }
    async componentDidMount() {
        const url = 'https://graph.facebook.com/v5.0/secureblink/posts?fields=attachments,created_time&access_token=EAAp70dBilqUBAFG7V12wn7M039ZCL6DbRhaaX1CZAUhbdmxA96ZBh3AotlTHZAa8nuz6UCZCPQxRsvX47ZCdUdezZCaZAOjtL3Ho5RNzFPnASA9Dr0joR9w653wotk3LaXkpNZASZCj2VtmpXZCUhmmCfF4k54ZArO1nnZCY5fLts8VkYenvNogoHrRSZA';
        const response = await fetch(url);
        const data = await response.json();
        const main_data = data.data.slice(0, 4);
        this.setState({ data: main_data });
    }
    render() {
        const params = {
            direction: 'vertical',
            slidesPerView: 1,
            spaceBetween: 30,
            effect: 'flip',
            mousewheel: true,
            pagination: {
                el: '.blog-slider__pagination',
                clickable: true,
            },
        }
        return (
            <Fragment>
                {/* <div className="blog-slider"> */}
                <div className="blog-slider">
                    <div className="blog-slider__wrp swiper-wrapper">
                        <Swiper {...params}>
                            {this.state.data.map((indiData, key) => {
                                return <div key={key} className="blog-slider__item swiper-slide">
                                    <div className="blog-slider__img">
                                        <img className="blgimg" src={indiData.attachments.data[0].media.image.src} alt="" />
                                    </div>
                                    <div className="blog_slider__content">
                                        <span className="blog-slider__code">{DateTimeHelper.formatDateTime(indiData.created_time)}</span>
                                        <div className="blog-slider__title">{indiData.attachments.data[0].title ? indiData.attachments.data[0].title : null}</div>
                                        <div className="blog-slider__text">{indiData.attachments.data[0].description ? indiData.attachments.data[0].description : null} </div>
                                        <a href={indiData.attachments.data[0].target.url} className="blog-slider__button">READ MORE</a>
                                    </div>
                                </div>
                            })}
                        </Swiper>
                    </div>
                </div>
                <div className="blog-slider__pagination"></div>
                {/* </div> */}
            </Fragment >
        )
    }
}

export default Blog2;